import RawCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { SingleLineText, Checkbox, Button as RawButton } from '@bloomays-lib/ui.shared';
import RawCardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import { CRAStatus } from '@bloomays-lib/types.shared';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { convertDateToStringFormat } from '@bloomays-lib/utils.shared';

export type ActionZeroCRAProps = {
  missionId: string;
  missionLabel: string;
  activityMonth?: Date;
  craStatus: CRAStatus;
  clickHandler: () => Promise<void> | void;
};

const ActionZeroCRA = ({ missionId, craStatus, clickHandler, missionLabel, activityMonth }: ActionZeroCRAProps) => {
  const [accepted, setAccepted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setLoading(true);
    setAccepted(checked);
    setLoading(false);
  };

  const handleClick = async () => {
    if (!accepted) return;
    setLoading(true);
    await clickHandler();
    setLoading(false);
  };

  return (
    <Card>
      <CardContent>
        <StyledTypo>{missionLabel}</StyledTypo>
        <ContainerData>
          <ContainerTextLabel>
            <CenteredSingleLineText text={`Etat: `} span={craStatus} />
          </ContainerTextLabel>
          <ContainerTextLabel>
            <CenteredSingleLineText text={`Mission Id: `} span={missionId} />
          </ContainerTextLabel>
          {activityMonth ? (
            <ContainerTextLabel>
              <CenteredSingleLineText text={`Mois: `} span={convertDateToStringFormat(activityMonth, 'MM/yyyy')} />
            </ContainerTextLabel>
          ) : null}
        </ContainerData>
      </CardContent>
      <CardActions>
        <Checkbox
          label={
            'Cette action créera ou réutilisera un CRA à zéro pour ce mois et cette mission, sans déclencher de facturation ni de signature client.'
          }
          id={'accept-zero-cra'}
          name={'accept-zero-cra'}
          checked={accepted}
          onChange={handleChange}
        />
        <Button
          id="validate-zero-cra"
          onClick={handleClick}
          textButton="Déclarer le CRA à zéro"
          loading={loading}
          disabled={loading || !accepted}
        />
      </CardActions>
    </Card>
  ) as React.ReactNode;
};

export default ActionZeroCRA;
export { ActionZeroCRA };

const Card = styled(RawCard)(() => ({
  width: '100%',
  margin: '1.5em 0',
  paddingBottom: 10,
  paddingTop: 10,
  boxShadow: '2px 2px 20px lightgrey !important',
  borderRadius: '10px !important',
}));

const StyledTypo = styled(Typography)(() => ({
  padding: '0px 0px 16px 16px',
  fontWeight: 'bold',
}));

const ContainerData = styled('div')(() => ({
  paddingLeft: 16,
}));

const CenteredSingleLineText = styled(SingleLineText)(() => ({}));

const CardActions = styled(RawCardActions)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}));

const ContainerTextLabel = styled('div')(() => ({
  display: 'flex',
}));

const Button = styled(RawButton)(({ theme }) => ({
  border: 'none',
  padding: '0.7em 1.4em',
  marginRight: 10,
  borderRadius: '8px',
  backgroundColor: theme.palette.red[60],
  color: theme.palette.neutral.white,
  boxShadow: '2px 2px 5px rgb(201, 201, 201)',
  paddingRight: '16px',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.neutral.white,
    color: theme.palette.blue[60],
    transition: '0.52s ease',
  },
}));
